import React, { Component } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import styles from './defaultStyles';
import PropTypes from 'prop-types';

class HandsFreeSearch extends Component {
  state = { searchText: '' };
  handleNewRequest = (value) => {
    const duplicateKey = this.props.selectedAttributes.findIndex(attr => attr.key === value);
    if (duplicateKey === -1) {
      let selectedAttributes = [...this.props.selectedAttributes];
      const searchText =  value.toUpperCase();
      selectedAttributes.push({ key: searchText, label: searchText });
      this.props.onChange(selectedAttributes);
    }
    /* clear autocomplete */
    setTimeout(() => {
      const {searchText} = this.state;
      this.props.autocompleteRef.setState({searchText});
      this.props.autocompleteRef.focus();
    }, 700);
  };
  handleUpdateInput = (searchText) => {
    this.props.onUpdate(searchText)
  }
  getAttributes = () => {
    const { 
      general, 
      brands,
      categoryNames, 
      flavors,
      effects } = this.props.config;
    return general
            .concat(brands)
            .concat(categoryNames) 
            .concat(flavors)
            .concat(effects);
  }

  render() {
    return (
        <AutoComplete
          ref={this.props.setRef}
          hintText="Search"
          onNewRequest={this.handleNewRequest}
          underlineFocusStyle={{ borderColor: '#' +this.props.config.secondaryColor }}
          dataSource={this.getAttributes()}
          filter={(searchText, key) => {
              return searchText !== '' && key.indexOf(searchText.toUpperCase()) !== -1;
            }
          }
          openOnFocus={false}
          textFieldStyle={styles.textFieldStyle}
          style={styles.textFieldStyle}
          onUpdateInput={this.handleUpdateInput.bind(this)}
        />
    );
  }

}

HandsFreeSearch.propTypes = {
  config: (props, propName) => {
    const config = props[propName];

    if (!config.hasOwnProperty('general')) {
      throw new Error('\'config\' must have \'general attributes\'.')
    }

    if (!config.hasOwnProperty('brands')) {
      throw new Error('\'config\' must have \'brands\'.')
    }

    if (!config.hasOwnProperty('categoryNames')) {
      throw new Error('\'config\' must have \'category names (product names)\'.')
    }

    if (!config.hasOwnProperty('flavors')) {
      throw new Error('\'config\' must have \'flavors\'.')
    }

    if (!config.hasOwnProperty('effects')) {
      throw new Error('\'config\' must have \'effects\'.')
    }
  },
  selectedAttributes: PropTypes.array,
  onChange: PropTypes.func,
}

export default HandsFreeSearch;



// WEBPACK FOOTER //
// ./src/components/HandsFreeSearch/HandsFreeSearch.jsx